<template>
  <div class="pack_slots_container b-radius-12">
    <div class="image_container">
      <img
        src="/images/piggy_bank.webp"
        alt="piggy_bank"
        class="piggy_bank_image"
      />
    </div>
    <div
      class="d-flex-row space-between height-max-content gap-50 description-container"
    >
      <div class="d-flex-column justify-start align-start gap-3">
        <div class="pack_slot_title" v-html="title"></div>
        <p
          class="pack_slot_description medium-m font-family-2 t-grey"
          v-html="description"
        ></p>
      </div>

      <button
        class="primary filled height-36 medium b-radius-6 font-family-1 regular-m f-w-600 white-space-no"
        @click="navToCheckout"
      >
        {{ $t("pack_slot.book_a_slot") }}
      </button>
    </div>
  </div>
</template>

<script setup>
const gameStore = useGameStore();
const { t } = useI18n();
const title = computed(() => {
  if (!gameStore?.getGamePack?.pack_slots) return "";
  return `${t("pack_slot.title_1")}<span>${
    gameStore.getGamePack?.pack_slots?.remaining_slot
  }${t("pack_slot.title_2")}</span>${t("pack_slot.title_3")}<span>${
    gameStore.getGamePack?.pack_slots?.season_title
  }</span>${t("pack_slot.title_4")}`;
});

const description = computed(() => {
  if (!gameStore?.getGamePack?.pack_slots) return "";
  const packSlot = gameStore?.getGamePack?.pack_slots;
  const packTitle = gameStore?.getGamePack?.short_title;
  const pickedSlots = packSlot?.total_slots - packSlot?.remaining_slot;
  return `${pickedSlots}${t("pack_slot.description_1")}${
    packSlot?.total_slots
  }${t("pack_slot.description_2")}${packSlot?.season_title}${t(
    "pack_slot.description_3"
  )}"${packTitle}"${t("pack_slot.description_4")}`;
});

const navToCheckout = () => {
  const el = document.getElementById("checkout_btn");
  if (!el) return;
  el.scrollIntoView({ behavior: "smooth", block: "center" });
};
</script>

<style lang="scss">
@import "../../assets/scss/fonts.scss";

.pack_slots_container {
  width: 100%;
  border-radius: 12px;
  border: 1px solid var(--Stroke-Card-Orange, #171819);
  height: max-content;
  min-height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 30px;
  position: relative;
  overflow: hidden;

  & > * {
    z-index: 1;
  }
  .description-container {
    padding: 20px;
    padding-left: 0px;
  }
  .image_container {
    width: 100%;
    max-width: 124px;
    position: relative;
    overflow: hidden;
    min-height: 80px;
    .piggy_bank_image {
      position: absolute;
      width: 100%;
      height: auto;
      max-width: 124px;
      transform: rotate(-15deg) scaleX(-1);
    }
  }
  .pack_slot_title {
    @extend .bold-xxl;
    @extend .font-family-2;
    span {
      @extend .t-orange;
    }
  }
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 12px !important;
    -moz-border-radius: 12px !important;
    -webkit-border-radius: 12px !important;
    background: var(--orange, #ff9e48);
    filter: blur(100px);
    top: 0;
    opacity: 0.3;
    left: -100%;
    transform: translate(50%, 0%);
  }
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 12px !important;
    -moz-border-radius: 12px !important;
    -webkit-border-radius: 12px !important;
    padding: 1px; /* control the border thickness */
    background: linear-gradient(
      45deg,
      #ff9e48,
      #171819,
      #171819,
      #171819,
      #ff9e48
    );
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;
    .image_container {
      position: absolute;
      left: 0;
      display: none;
    }
    .description-container {
      padding-left: 20px;
      flex-direction: column;
      gap: 20px;
      button {
        width: 100%;
      }
    }
  }
}
</style>
